import Formsy from 'formsy-react';
import React from 'react';
import {Input} from '../form';
import {changePassword} from '../../api/'

class ChangePasswordForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showErrors: false,
      isProcessing: false,
      message: null,
      messageIsError: false,
      isPristine: true
    };

  }

  onValidSubmit(model) {

    const { isPristine } = this.state;
    if (isPristine) return;

    this.setState({isProcessing: true, serverError: null});

    changePassword(model.password1)
      .then(() => {
        this.setState({
          isProcessing: false,
          message: "Your changes were applied successfully.",
          messageIsError: false
        });
      })
      .catch((e) => {
        this.setState({
          isProcessing: false,
          message: e.message,
          messageIsError: true
        });
      });

  }

  onInvalidSubmit() {
    this.setState({ showErrors: true });
  }

  render() {

    const { showErrors, isProcessing, message, messageIsError, isPristine } = this.state;

    return (
      <Formsy onValidSubmit={(model) => this.onValidSubmit(model) }
              onChange={(values, isChanged) => this.checkForPristine(values, isChanged) }
              onInvalidSubmit={() => this.onInvalidSubmit() }
              ref="form">
        <div className="form-fields">
          <Input name="password1"
                 type="password"
                 icon="build"
                 label="Password"
                 showErrors={showErrors}
                 required />
          <Input name="password2"
                 type="password"
                 icon="key"
                 label="Password Repeat"
                 showErrors={showErrors}
                 required />
          </div>
          <div className="form-submit-group grid-row">
            <div className="grid-item grid-row v-align">
              {message && (
                <div className={"message" + (messageIsError ? " error-message" : "")}>
                  {message}
                </div>
              )}
            </div>
            <div>
              <button className={"pt-button sr2" + (isPristine ? " pt-disabled" : "")}
                      type="button"
                      onClick={() => this.onCancel() }>Cancel</button>
              {!isProcessing ? (
                <button type="submit"
                        className={"pt-button pt-intent-primary" + (isPristine ? " pt-disabled" : "")}>Submit</button>
              ) : (
                <button type="submit"
                        className="pt-button pt-disabled ">Submitting...</button>
              )}
            </div>
          </div>
      </Formsy>
    );
  }

  checkForPristine(values, isChanged) {
    this.setState({isPristine: !isChanged, message: null});
  }

  onCancel() {

    const { isPristine } = this.state;
    if (isPristine) return;

    this.refs.form.reset();
    this.setState({
      message : "Your changes have been discarded.",
      messageIsError: false
    });
  }
}

export default ChangePasswordForm;


// WEBPACK FOOTER //
// ./src/components/forms/ChangePasswordForm.js